// 目前暂时无法区分 司机app，用户app和企业app
// 企业app的token存储于ua中
// android下可以正常获取ua，并解析出token
// ios下，为了兼容低版本ios，获取ua的过程是异步的，解析token在回调函数中进行，目前将这一过程封装成promise使用
// 在chrome中模拟ios环境时，由于promise中的回调无法返回，因此promise会使程序停止在获取token这一步
// 所以除了localhost以外，其他的调试和开发ua请不要模拟ios环境
import { isIOS } from '@/utils';
function setAppInfoByUserAgent(ua) {
  let arr = [];
  console.log('ua30:' + ua);
  let res = ua.match(/huolala\((.*?)\)/);
  if (res && res.length && res.length === 2) {
    // arr = [revision, os, channel, version, device_type, device_id, token]
    arr = res[1].split(',');
  } else {
    return;
  }
  console.log('arr:' + arr);
  if (arr.length >= 7) {
    // 把revision, os, channel, version, device_type, device_id, token信息设置到cookie中
    // sessionStorage.setItem('revision', arr[0]);
    // sessionStorage.setItem('os', arr[1]);
    // sessionStorage.setItem('channel', arr[2]);
    // sessionStorage.setItem('version', arr[3]);
    // sessionStorage.setItem('device_type', arr[4]);
    // sessionStorage.setItem('device_id', arr[5]);
    // sessionStorage.setItem('token', arr[6]);
    return typeof arr[6] == 'string' && !/null/.test(arr[6]) ? arr[6] : null;
  }
}
let iOSGetToken = function() {
  return new Promise(resolve => {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.app
    ) {
      window.shareResult = function(textUserAgent) {
        // 修改手机参数
        let token = setAppInfoByUserAgent(textUserAgent);
        resolve(token);
      };
      window.webkit.messageHandlers.app.postMessage(
        JSON.stringify({
          action: 'getAppInfo',
          callback: 'shareResult' // 兼容ios2.0写死的方法名
        })
      );
    } else {
      resolve(false);
    }
  });
};
function getCompanyToken() {
  return new Promise(async resolve => {
    let token = '';
    let ua = navigator.userAgent;
    // dev环境
    if (/localhost/.test(location.hostname)) {
      ua =
        'huolala(2200,android,,2.2,vivo X6A,86896602662419013,HLLEec7bed302eb338d4731f279ed17ef69f)';
      return resolve('HLLEec7bed302eb338d4731f279ed17ef69f');
    }
    if (isIOS()) {
      //超时处理,当测试环境时ios端获取不到token时
      //2秒后超时
      setTimeout(() => resolve(false), 2000);
      token = await iOSGetToken();
    } else {
      token = setAppInfoByUserAgent(ua);
    }
    return resolve(token);
  });
}
export default getCompanyToken;
